import { ICategory, States } from 'safe'
import {
  CategoriesTypes,
  CREATE_CATEGORY,
  SET_CATEGORIES,
  UPDATE_CATEGORY,
  DELETE_CATEGORY,
  CREATE_SUBCATEGORY,
  SubcategoriesTypes,
  UPDATE_SUBCATEGORY,
  DELETE_SUBCATEGORY,
} from '../actions/actionTypes'

const initialState: States.Categories = {
  categories: [],
}

let _categories, index, updatedCategory, subIndex, children

//recursive insert
// const insertChild = (category: ICategory, categories: ICategory[]) => {
//   if (category.parent === null) categories.push(category)
//   else {
//     categories.forEach((c) => {
//       if ((category.parent || 0) === c.id) {
//         // si la categoria agregada matchea su parent se agrega al array
//         c.children.push(category)
//       } else if (c.children.length > 0) {
//         // de no encontrarla la busca en sus hijos
//         c.children = insertChild(category, c.children)
//       }
//     })
//   }
//   console.log(categories)
//   return [...categories]
// }

//eslint-disable-next-line
export default (
  state = initialState,
  action: CategoriesTypes | SubcategoriesTypes
): States.Categories => {
  switch (action.type) {
    case SET_CATEGORIES:
      return { ...state, categories: action.payload }
    case CREATE_CATEGORY:
      // console.log(state.categories)
      // console.log(action.payload)
      // const _categories = insertChild(action.payload, state.categories)
      // console.log(_categories)
      const newCategories = [...state.categories, action.payload]
      return { ...state, categories: newCategories }
    case UPDATE_CATEGORY:
      _categories = [...state.categories]
      index = _categories.findIndex((i) => i.id === action.payload.id)
      _categories[index] = { ..._categories[index], ...action.payload }
      return { ...state, categories: _categories }
    case DELETE_CATEGORY:
      _categories = [...state.categories]
      index = _categories.findIndex((i) => i.id === action.payload)
      _categories.splice(index, 1)
      return { ...state, categories: _categories }

    case CREATE_SUBCATEGORY:
      _categories = [...state.categories]
      index = _categories.findIndex((i) => i.id === action.payload.idCategory)
      updatedCategory = _categories[index].children.push(action.payload)
      _categories[index] = { ..._categories[index], ...updatedCategory }
      return { ...state, categories: _categories }

    case UPDATE_SUBCATEGORY:
      _categories = [...state.categories]
      index = _categories.findIndex((i) => i.id === action.payload.idCategory)
      subIndex = _categories[index].children.findIndex(
        (i) => i.id === action.payload.id
      )
      _categories[index].children[subIndex] = action.payload
      return { ...state, categories: _categories }

    case DELETE_SUBCATEGORY:
      _categories = [...state.categories]
      index = _categories.findIndex((i) => i.id === action.payload.idCategory)
      // subIndex = _categories[index].findIndex((i) => i.id === action.payload.id)
      // _categories[index].children.splice(subIndex, 1)
      // console.log("VEr", _categories)
      children = [..._categories[index].children]
      children = children.filter((child) => child.id !== action.payload.id)
      _categories[index] = { ..._categories[index], children }
      return { ...state, categories: _categories }
    default:
      return state
  }
}
